import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import Div from "../../../widget/common/ui/Div";
import { NoticesListContextImport } from "../../../provider/notices/notices_list/NoticesListContextProvider";
import { FollowingNoticesList } from "../../../model/notices/NoticesListModel";
import Loader from "../../../widget/common/ui/Loader";
import Center from "../../../widget/common/ui/Center";
import NoticesListing from "./widget/NoticesListing";
import NoData from "../../../widget/common/ui/NoData";
import SearchInput from "../../../widget/common/form/SearchInput";

const NoticesListContent = (props: { type?: number | undefined }) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  const {
    getNoticesListAPI,
    noticesList,
    onClickNotice,
    handlePressStart,
    handlePressEnd,
    selectedNoticeIds,

    searchValue,
    showSearch,
    handleOnChange,
    clearSearch,
  } = NoticesListContextImport();

  const [notices, setNotices] = useState<Array<FollowingNoticesList> | null>(
    null
  );

  useEffect(() => {
    getNoticesListAPI();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (noticesList != null) {
      const sortedList = [...noticesList!].sort(
        (a, b) =>
          new Date(b?.create_date!).getTime() -
          new Date(a?.create_date!).getTime()
      );
      setNotices(sortedList);
    }
  }, [noticesList]);

  return (
    <Div className={` pt-lg-4 pb-5 h-100`}>
      {showSearch && (
        <SearchInput
          name="search-notices"
          placeHolder="search"
          handleOnChange={handleOnChange}
          onClickSuffix={clearSearch}
          value={searchValue}
          autoFocus={true}
          listLogic={true}
        />
      )}

      {noticesList == null ? (
        <Center className="h-100">{Loader.normal()}</Center>
      ) : noticesList.length === 0 ? (
        <Center>
          <NoData />
        </Center>
      ) : (
        <>
          <NoticesListing
            notices={notices}
            type={type}
            onClickNotice={onClickNotice}
            handlePressStart={handlePressStart}
            handlePressEnd={handlePressEnd}
            selectedIds={selectedNoticeIds}
          />
        </>
      )}
    </Div>
  );
};

export default NoticesListContent;
